import { Space } from "antd"

export { Space }
